export default "__VITE_ASSET__BRMyJcDU__"